module.exports = __webpack_public_path__ + "assets/img/wallet-icon2-s.5f47ea54.png";